import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, id) => appendPaginationQueryParamsToUrl(`${host}/short_links/${id}?include=shortLinkTargets`)

export default host => options =>
    get(url(host, options))
        .then(response => response.json())
        .then(json => json.meta ? json : json.data)